module.exports = __webpack_public_path__ + "static/media/21.dfdc9074.jpg";